import {JSONModel, jsonProperty} from "../json.model";

export interface PercentageBarModel {
  title?: string;
  value?: number;
  type?: string;
  width?: number;
}

export function percentageBarModelFactory(json?: any) {
  json = json || {};

  return {
    title: json.title || "",
    value: +json.value || 0,
    type: json.type || "",
    width: +json.width || 0,
  };
}

export class ProgressBarModel extends JSONModel {
  @jsonProperty("boolean") visible: boolean;
  @jsonProperty("string") title: string;
  @jsonProperty("number0") value: number;
  @jsonProperty("string") type: string;
  @jsonProperty("number0") width: number;
}
